import { Api } from '@/services/AxiosService'

const actions = {
  async fetchSettings(ctx) {
    const {
      data: { data },
    } = await Api.fetchSettings()

    ctx.commit('setSettings', data)
  },
  async fetchLogoContent(ctx) {
    const {
      data: { data },
    } = await Api.fetchLogoData()
    ctx.commit('setLogo', data)
  },
}
const mutations = {
  setSettings(state, data) {
    state.settings = data
  },
  setLogo(state, data) {
    state.logoData = data
  },
}
const getters = {
  getSettings(state) {
    return state.settings
  },
  getLogoData(state) {
    return state.logoData
  },
}
const state = {
  settings: [],
  logoData: {},
}

export default {
  state,
  getters,
  mutations,
  actions,
}
